import React from 'react';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import './ManageColumnsModal.css';

const ManageColumnsModalFooter = (props) => {
  return (
    <div id="ManageColumnsModalFooter" className="ManageColumnsModalFooter">
      <button
        id="ManageColumnsModalFooter_CancelButton"
        className="ManageColumnsModalFooter_CancelButton"
        onClick={() => {
          props.afterModalClose();
        }}
      >
        Cancel
      </button>

      <button
        id="ManageColumnsModalFooter_ApplyButton"
        className="ManageColumnsModalFooter_ApplyButton"
        disabled={props.updatingPreference}
        onClick={(event) => {
          props.handleApplyButton();
          event.preventDefault();
        }}
      >
        {props.updatingPreference ? BUTTON_LOADING_CIRCLE : 'Apply'}
      </button>
    </div>
  );
};

export default ManageColumnsModalFooter;
